import React from 'react';
import styled,{keyframes} from 'styled-components';
import Slider from './Slider';
import {words} from './translations';

const Question = ({ question, id, saveResponse, setScreen, response, language, tone = 'balanced' }) => {

  const getQuestion = () => {
    if(language=="EN"){
      return question.question
    }
    if(language=="FR"){
      return question.fr
    }
    if(language=="ES"){
      return question.es
    }
  }

  // Different styling based on tone
  const getToneStyle = () => {
    // Use the same blue color for all tones to maintain consistent UI
    return { color: '#2D70E2', subtitle: language === 'EN' ? 'Balanced Approach' : language === 'FR' ? 'Approche équilibrée' : 'Enfoque equilibrado' };
  };
  
  const { color, subtitle } = getToneStyle();
    
 return (
  <QuestionContainer key={question.id}>
    <Title style={{ color }}>
    Demo Question
    </Title>
    <QuestionText>{getQuestion()}</QuestionText>
    <Slider 
      id={`slider-track-${id}`} 
      question={question}
      language={language}
      tone={tone}
      saveUpdatedAnswers={saveResponse}/>

    <ButtonArea>
      <Button onClick={()=>setScreen()} disabled={response==undefined} style={{ backgroundColor: color }}>
        {words['Next'][language]}
      </Button>
    </ButtonArea>
  </QuestionContainer>
 )
};
export default Question;



const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const QuestionContainer = styled.div`
  width: 100%;
  max-width:600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  opacity:0;
  animation: ${fadeIn} 1s ease-out forwards;
`;

const Title = styled.div`
  text-transform: uppercase;
  font-size:14px;
  font-weight:600;
  margin-bottom: 10px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #6B7280;
`;

const Qualifier = styled.div`
  color:#2A3039;
  font-size:16px;
  font-weight:600;
  margin-bottom:14px;
  line-height:1.4;
`;

const QuestionText = styled.p`
  font-size: 16px;
  font-weight:400;
  color: #2A3039;
`;


const ButtonArea = styled.div`
    display: flex;
    width:100%;
    justify-content: flex-end;
    margin-top: 20px;
`;

const Button = styled.button`
    color: white;
    font-size: 16px;
    font-weight: 400;
    border: none;
    border-radius: 5px;
    padding: 10px 35px;
    cursor: pointer;
    transition: all 0.3s;
    margin-top:40px;
    
    &:hover {
        opacity: 0.9;
    }

    &:disabled {
        background-color: #ccc !important;
        cursor: not-allowed;
    }
`;